import { put, call, select, takeLatest } from 'redux-saga/effects';
// components
import { closeModal } from '../../components/modal/actions';
import { closeLoader, openLoader } from '../../components/loader/actions';
// features
import { makeSelectCurrentBranchGuid } from '../branch/selectors';
// utilities
import { sendRequest } from '../../utilities/http';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// sagas
import { crudSaga, visitPageSaga } from '../../sagas';
// utilities
import endpointsMap from '../../utilities/endpoints';
// feature route-mass-create-report
import * as A from './actions';
import { makeSelectPagination } from './selectors';
//////////////////////////////////////////////////

function* handleGetRouteMassCreateListSaga() {
  try {
    yield put(A.setListLoading(true));

    const pagination = yield select(makeSelectPagination());
    const currentEnterprise = yield select(makeSelectCurrentBranchGuid());

    const { limit, offset } = pagination;

    const reqData = {
      limit,
      offset,
      currentEnterprise,
    };

    const res = yield call(sendRequest, 'post', endpointsMap.routeMassCreateReportList, { data: reqData });

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      yield put(A.getItemListSuccess(data));
    } else {
      yield call(G.handleFailResponse, res, 'handleGetRouteMassCreateListSaga fail');
    }

    yield put(A.setListLoading(false));
    yield put(closeLoader());
  } catch (err) {
    yield put(A.setListLoading(false));
    yield put(closeLoader());

    yield call(G.handleException, err, 'getRouteMassCreateListSaga exception');
  }
}

function* handleDeleteRouteMassCreateItemSaga({ payload }) {
  try {
    yield put(openLoader({ showDimmer: true }));

    const options = { data: payload };

    yield call(crudSaga, {
      options,
      payload,
      method: 'delete',
      successAction: A.deleteItemsSuccess,
      endpoint: endpointsMap.routeMassCreateReport,
      parentSagaName: 'deleteRouteMassCreateItemSaga',
    });

    yield put(closeModal());
    yield put(closeLoader());
  } catch (error) {
    yield put(closeLoader());

    yield call(G.handleException, error, 'handleDeleteRouteMassCreateItemSaga exception');
  }
}

function* handleVisitRouteMassCreateReportSaga({ payload }) {
  while (true) { // eslint-disable-line
    yield call(visitPageSaga, payload, GC.CHECK_VISIT_ROUTE_MASS_CREATE_REPORT_PAGE);

    yield put(openLoader({ showDimmer: true }));
    yield put(A.setInitialState());
    yield put(A.getItemListRequest());
    yield put(closeLoader());

    break;
  }
}

function* RouteMassCreateReportWatcherSaga() {
  yield takeLatest(A.getItemListRequest, handleGetRouteMassCreateListSaga);
  yield takeLatest(A.deleteItemsRequest, handleDeleteRouteMassCreateItemSaga);
  yield takeLatest(GC.VISIT_ROUTE_MASS_CREATE_REPORT_PAGE, handleVisitRouteMassCreateReportSaga);
}

export default RouteMassCreateReportWatcherSaga;
